import styled from 'styled-components';
import { lightColorPalette } from '@linearb/linui-common';
import { getRoundedValue } from '../../../../ResourceAllocationOverview/resource-allocation.formatters';

const StyledAvgVelocityInfo = styled.div`
  margin-left: 2rem;
  display: flex;
  align-items: center;
  background-color: ${lightColorPalette.lbOrange_10};
  padding: 0.5rem 1.5rem;
  font-size: 1.2rem;

  & > main {
    font-size: 1.2rem;
  }
  & > section {
    font-size: 1rem;
    margin-left: 0.5rem;
  }
`;

const AvgVelocityInfo = ({ granularity, avgVelocity, type }) => {
  const granularityStr = granularity?.name.toLowerCase();
  const roundedAvgVelocity = getRoundedValue(avgVelocity);

  return (
    <StyledAvgVelocityInfo>
      <main>
        {roundedAvgVelocity} {type.name}
      </main>
      <section>average {granularityStr} velocity</section>
    </StyledAvgVelocityInfo>
  );
};

export default AvgVelocityInfo;
